
import { useState } from "react";
import PostsFeeds from "../../components/posts_feed";

function Posts(){

    return(
        <div>
            <PostsFeeds/>
        </div>
    )
}

export default Posts;